import { displaySetting, updateDisplay } from '@/page/wlanPlanner/components/displaySetting/model/type';

const state:displaySetting = {
    planarOpacity: 80, // 平面图不透明度
    barrierOpacity: 80, // 障碍物不透明度
    barrierWidth: 3, // 障碍物粗细
    deviceIconSize: 3, // 设备图标大小
    showCableTopology: true, // 是否显示网线拓扑
    showHeatMapColorBanding: true, // 是否显示热图色带
    showMaxMinSignalIntensity: true, // 是否显示⾊带最⼤、最⼩信号强度
    showDeviceName: true, // 是否显示设备名称
    showApChannel: true, // 是否显示AP信道
    showDeviceModel: true, // 是否显示设备机型
    showSimulation: true, // 是否显示仿真
    showScale: true // 是否显示比例尺
};
const mutations = {
    setDisplaySetting: (state:any, setting:updateDisplay) => {
        Object.assign(state, setting);
    }
};

export default {
    namespaced: true, // 这个是命名空间，用来区分不同的模块，我是根据文件的名字来区分
    state,
    mutations
};
